import { Injectable } from "@angular/core";
import { CreateBookingWS } from "@app/core/booking/data/network/create-booking.ws";
import { Booking } from "@app/core/booking/domain/model/booking";
import { GetMarketingMessageWS } from "@app/core/marketing/data/network/get-marketing-message.ws";
import { MarketingMessage } from "@app/core/marketing/domain/marketing-message";
import { MarketingMessageRepo } from "@app/core/marketing/domain/marketing-message.repo";
import { Observable } from "rxjs";

@Injectable()
export class MarketingMessageRepoImpl implements MarketingMessageRepo {
  constructor(private getMarketingMessageWS: GetMarketingMessageWS) {}

  getMarketingMessage(token: string): Observable<MarketingMessage> {
    return this.getMarketingMessageWS.execute(token);
  }
}
